import { VisualSection, MessagingSection, AiccSection, CtaSection } from "@/components/home";

const Home = () => {
  return (
    <main className="mt-[75px]">
      {/* ===== 비주얼 섹션 ===== */}
      <VisualSection />

      {/* ===== 메시징 섹션 ===== */}
      <MessagingSection />

      {/* ===== AICC 섹션 (문자콜센터) ===== */}
      <AiccSection />

      {/* ===== CTA 섹션 ===== */}
      <CtaSection />
    </main>
  );
};

export default Home;
